module.exports = __webpack_public_path__ + "img/verydissatisfied_green.5d219d04.png";